/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import ModalBodyLayout from '../../../shared/ModalBodyLayout';
import CurrencyCard from '../../partials/CurrencyCard';
import { RATES_QUERY_KEY } from '../../../../utilities/sharedQueries';

const Currencies = ({
  wallets,
  mainScreen,
  openScreen,
  updateForm,
  form,
  currencies,
  isOpenSourceCurrencies,
}) => {
  const { t: translate } = useTranslation();
  const { data: rates } = useQuery(RATES_QUERY_KEY);
  const [searchValue, setSearchValue] = useState('');
  const [renderedCurrencies, setRenderedCurrencies] = useState(currencies);
  const handleSearchInput = (event) => {
    setSearchValue(event.target.value);
  };

  useEffect(() => {
    if (searchValue) {
      const filterWallets = currencies.filter(
        (c) =>
          c.currency_code.toLowerCase().includes(searchValue.toLowerCase()) ||
          c.currency_name?.toUpperCase().search(searchValue.toUpperCase()) >= 0
      );
      setRenderedCurrencies(filterWallets);
    } else {
      setRenderedCurrencies(currencies);
    }
  }, [searchValue, currencies]);

  const chooseWallet = (data) => {
    if (isOpenSourceCurrencies) {
      const _sourceWallet = wallets.find((w) => w.coin === data.currency_code);
      updateForm({ ...form, source: data, sourceWallet: _sourceWallet });
    } else {
      const _destinationWallet = wallets.find((w) => w.coin === data.currency_code);
      updateForm({ ...form, destination: data, destinationWallet: _destinationWallet });
    }
  };

  return (
    <ModalBodyLayout
      title={translate('exchange_source_wallets_title')}
      onPrevClick={() => openScreen(mainScreen)}
      withBack>
      <div>
        <div className="my-3">
          <div className="rounded bg-light p-0 popup-search-input d-flex flex-row flex-row-reverse position-relative">
            <input
              type="text"
              value={searchValue}
              onChange={(e) => handleSearchInput(e)}
              className="form-control border-1 border-transparent bg-light shadow-none w-100 ps-5 d-flex"
              placeholder={translate('select_account_input_placeholder')}
            />
            <i className="position-absolute start-0 top-0 px-3 py-3 icon icon-search-other h-100 d-flex align-items-center justify-content-center text-shadow" />
            <i
              onClick={() => {
                setSearchValue('');
              }}
              onKeyDown={() => {}}
              role="button"
              tabIndex={0}
              label="close"
              hidden={searchValue === '' || searchValue === null || searchValue === undefined}
              className="icon icon-close-other text-white position-absolute top-50 end-0 translate-middle-y pe-3"
            />
          </div>
        </div>
        <div style={{ maxHeight: '30rem' }}>
          {renderedCurrencies.map((item) => {
            const rateKey = form.checkOpenForExchange
              ? `${form.source.currency_code?.toUpperCase()}${item.currency_code.toUpperCase()}`
              : `${form.destination.currency_code?.toUpperCase()}${item.currency_code.toUpperCase()}`;

            const currentRate = rates[rateKey];

            if (!currentRate || (currentRate && !currentRate?.availableOnExchange)) {
              return <></>;
            }
            return (
              <CurrencyCard
                wallets={wallets}
                key={item.id}
                data={item}
                openScreen={openScreen}
                chooseWallet={chooseWallet}
                mainScreen={mainScreen}
              />
            );
          })}
        </div>
      </div>
    </ModalBodyLayout>
  );
};

export default Currencies;

Currencies.propTypes = {
  wallets: PropTypes.array.isRequired,
  openScreen: PropTypes.func.isRequired,
  updateForm: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  mainScreen: PropTypes.string.isRequired,
  currencies: PropTypes.array.isRequired,
  isOpenSourceCurrencies: PropTypes.bool.isRequired,
};
